(function () {
  try {
    const url = new URL(window.location.href);
    const path = url.pathname.replace(/\/+$/, "");

    // Fire if:
    //  - we're on /cart with a products param (Meta-style link), OR
    //  - we're on our explicit handoff routes (/cart/meta or /pages/cart-meta)
    const productsParam = url.searchParams.get("products");
    const isHandoffRoute =
      path.startsWith("/cart/meta") || path.startsWith("/pages/cart-meta");
    const shouldRun =
      (!!productsParam && path === "/cart") || isHandoffRoute;

    if (!shouldRun) return;

    // Preserve extra params for checkout (cart_origin, fbclid, utm_*)
    const checkoutParams = new URLSearchParams(url.search);
    checkoutParams.delete("products");
    const checkoutUrl = "/checkout" + (checkoutParams.toString() ? "?" + checkoutParams.toString() : "");

    if (!productsParam) {
      // explicit handoff route but no products → bail to cart
      window.location.replace("/cart");
      return;
    }

    // Parse "id:qty,id:qty", sum dups, ignore junk
    const itemMap = Object.create(null);
    productsParam.split(",").forEach(pair => {
      const [idRaw, qtyRaw] = pair.split(":");
      const id = Number(idRaw);
      const qty = Number(qtyRaw);
      if (Number.isInteger(id) && id > 0 && Number.isInteger(qty) && qty > 0) {
        itemMap[id] = (itemMap[id] || 0) + qty;
      }
    });

    const items = Object.keys(itemMap).map(id => ({ id: Number(id), quantity: itemMap[id] }));
    if (!items.length) {
      window.location.replace("/cart");
      return;
    }

    // Helpers
    const jsonPost = (endpoint, payload) =>
      fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        credentials: "same-origin",
        body: payload ? JSON.stringify(payload) : null
      });

    const clearCart = () => jsonPost("/cart/clear.js");

    // Toggle: true = replace existing cart; false = merge
    const REPLACE_CART = true;

    (async () => {
      try {
        if (REPLACE_CART) await clearCart();

        // Bulk add first
        let res = await jsonPost("/cart/add.js", { items });
        if (!res.ok) throw new Error("bulk add failed");

        // Success → straight to checkout (keep tracking params)
        window.location.replace(checkoutUrl);
      } catch (e) {
        // Fallback: add one-by-one so valid lines still get through
        let added = 0;
        for (const it of items) {
          try {
            const r = await jsonPost("/cart/add.js", { items: [it] });
            if (r.ok) added++;
          } catch (_) { /* continue */ }
        }
        window.location.replace(added > 0 ? checkoutUrl : "/cart");
      }
    })();
  } catch (e) {
    try { window.location.replace("/cart"); } catch (_) {}
  }
})();
